module.exports = __webpack_public_path__ + "static/media/beach-6.a9fd97b1.jpg";